import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextAreaField from 'components/TextAreaField';
import { Field } from 'react-final-form';
import BrokerPulsCheckActions from '../BrokerPulsCheckActions';

import './StillForSaleSection.styles.scss';
import './StillForSaleSection.styles.responsive.scss';

type StillForSaleSectionProps = {
  className?: string;
};

const StillForSaleSection: React.FC<StillForSaleSectionProps> = (props) => {
  const { className } = props;

  const classes = classNames('still-for-sale-section', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p className="steps">
        {t('stepsCurrentOf', { currentStep: 2, steps: 2 })}
      </p>

      <p className="title">{t('noLongerForSaleSectionTitle')}</p>

      <Field
        name="message"
        component={TextAreaField}
        label={t('sendAllYourLeadsMessage')}
        rows={5}
      />

      <BrokerPulsCheckActions />
    </div>
  );
};

export default StillForSaleSection;
